package com.anjuros.website.redesign.sections.faq

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdRichText
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.components.rdPlainText
import com.anjuros.website.redesign.styles.FaqHitStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Text

/** Case-insensitive pattern for the search words, or null when the search box is empty. */
fun faqSearchPattern(query: String): Regex? =
    query.trim().takeIf { it.isNotEmpty() }?.let { Regex(Regex.escape(it), RegexOption.IGNORE_CASE) }

/** True when there is no search, or the question or answer contains the search words (link markup ignored). */
fun faqMatches(pattern: Regex?, question: String, answer: String): Boolean =
    pattern == null || pattern.containsMatchIn(rdPlainText(question)) || pattern.containsMatchIn(rdPlainText(answer))

/** The text with its links; while searching, plain text with every match of [pattern] highlighted. */
@Composable
fun FaqHighlighted(text: String, pattern: Regex?) {
    if (pattern == null) {
        RdRichText(text)
        return
    }
    val plain = rdPlainText(text)
    var last = 0
    pattern.findAll(plain).forEach { match ->
        if (match.range.first > last) Text(plain.substring(last, match.range.first))
        RdTag("mark", FaqHitStyle.toModifier()) { Text(match.value) }
        last = match.range.last + 1
    }
    if (last < plain.length) Text(plain.substring(last))
}
